export class Speaker {
    idSpeaker: number;
    uid: string;
    nom: string;
    position: any;
    mail: string;
    tel: string;
    mobile: string;
    entreprise: string;
    description: string;
    typeBadge: string;

    idClient: number;
    pays: string;
    ordre: number;
    dateImpression: Date;
    status: string;
    type: string;



} 